import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";

import {
  Collapse,
  Tag,
  Table
} from '@lockerpm/design';

import itemsComponents from "../../../../../components/items";

import common from "../../../../../utils/common";
import paymentServices from "../../../../../services/payment";
import global from "../../../../../config/global";

const BillingDocuments = (props) => {
  const { Pagination } = itemsComponents;
  const {
    className
  } = props
  const { t } = useTranslation();

  const plans = useSelector((state) => state.resource.plans);
  const locale = useSelector((state) => state.system.locale);

  const [collapseKeys, setCollapseKeys] = useState([])
  const [invoices, setInvoices] = useState([]);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(false);
  const [params, setParams] = useState({
    page: 1,
    size: 10,
  });
  useEffect(() => {
    fetchInvoices();
  }, [params])

  const fetchInvoices = async () => {
    setLoading(true);
    await paymentServices.get_payments_invoices(params).then((res) => {
      setTotal(res.count)
      setInvoices(res.results);
    }).catch(() => {
      setTotal(0)
      setInvoices([])
    })
    setLoading(false);
  }

  const CollapseHeader = () => {
    return <p className="font-semibold">{t('plans_billing.billing_documents.title')}</p>
  }

  const getPlanByAlias = (alias) => {
    if (alias === global.constants.PLANS.ENTERPRISE) {
      return {
        name: 'Enterprise'
      }
    }
    if (alias === global.constants.PLANS.LIFETIME_PREMIUM) {
      return {
        name: 'Premium'
      }
    }
    if (alias === global.constants.PLANS.LIFETIME_FAMILY) {
      return {
        name: 'Family'
      }
    }
    if (alias === global.constants.PLANS.LIFETIME_TEAM) {
      return {
        name: 'Team'
      }
    }
    return plans.find(p => p.alias === alias) || {}
  }

  const handleChangePage = (page, size) => {
    setParams({
      ...params,
      page,
      size,
    })
  }

  const columns = useMemo(() => {
    return [
      {
        title: t('plans_billing.billing_documents.id'),
        dataIndex: 'payment_id',
        key: 'payment_id',
        align: 'left',
      },
      {
        title: t('common.created_time'),
        dataIndex: 'created_time',
        key: 'created_time',
        align: 'center',
        render: (_, record) => common.convertDateTime(record.created_time, 'LLL')
      },
      {
        title: t('common.plan'),
        dataIndex: 'plan',
        key: 'plan',
        align: 'left',
        render: (_, record) => getPlanByAlias(record.plan)?.name
      },
      {
        title: t('plans_billing.billing_documents.duration'),
        dataIndex: 'duration',
        key: 'duration',
        align: 'left',
        render: (_, record) => t(`common.${record.duration.toLowerCase()}`)
      },
      {
        title: t('plans_billing.billing_documents.total_price'),
        dataIndex: 'total_price',
        key: 'total_price',
        align: 'right',
        render: (_, record) => common.formatCurrency(record.total_price, 2, 'USD')
      },
      {
        title: t('common.status'),
        dataIndex: 'status',
        key: 'status',
        align: 'center',
        render: (_, record) => <Tag>
          {t(`plans_billing.billing_documents.${record.status}`)}
        </Tag>
      },
    ].filter((c) => !c.hide)
  }, [plans, locale])

  return (
    <div className={`billing-documents ${className}`}>
      <Collapse
        activeKey={collapseKeys}
        expandIconPosition={'end'}
        onChange={setCollapseKeys}
      >
        <Collapse.Panel
          key="1"
          header={<CollapseHeader/>}
        >
          <Table
            columns={columns}
            dataSource={invoices}
            loading={loading}
            pagination={false}
            rowKey={(record) => record?.payment_id}
            size="small"
            scroll={{ x: 1024 }}
          />
          {
            total > 10 && <Pagination
              params={params}
              total={total}
              onChange={handleChangePage}
            />
          }
        </Collapse.Panel>
      </Collapse>
    </div>
  );
}

export default BillingDocuments;